import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useReveal } from "@/lib/motion";
import { WORK_TOGETHER, SERVICES } from "@/lib/siteData";

// Right-pointing stroked arrow icon matching the design
const ArrowRight = ({ className = "h-[34px] w-[34px]" }) => (
    <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        aria-hidden="true"
        focusable="false"
    >
        <path d="M4 12h16" />
        <path d="M13 5l7 7-7 7" />
    </svg>
);

export const WorkTogether = () => {
    const reveal = useReveal();

    return (
        <section className="bg-paper px-6 pb-[92px] pt-[100px] text-center">
            <div className="mx-auto flex max-w-[980px] flex-col items-center">
                <motion.h2
                    className="type-display text-balance text-[clamp(32px,3.8vw,52px)] font-bold text-brand"
                    {...reveal()}
                >
                    {WORK_TOGETHER.headline}
                </motion.h2>

                <motion.p
                    className="mt-3 max-w-[380px] text-[clamp(16px,1.5vw,20px)] leading-snug text-ink"
                    {...reveal(0.08)}
                >
                    Toda grande marca começa com
                    <br />
                    uma ideia bem construída.
                </motion.p>

                {/* 4 Services with larger typography and tighter grouping */}
                <ul className="mt-12 grid w-full grid-cols-2 gap-x-6 gap-y-10 sm:grid-cols-4 sm:gap-x-6 md:gap-x-8 lg:gap-x-10 text-brand">
                    {SERVICES.map((service, index) => (
                        <motion.li
                            key={service.slug}
                            {...reveal(0.12 + index * 0.08)}
                            className="flex justify-center"
                        >
                            <Link
                                to={`/servicos/${service.slug}`}
                                className="group flex flex-col items-center gap-4 text-center"
                            >
                                <span className="flex h-[42px] w-[42px] items-center justify-center transition-transform duration-200 ease-out group-hover:translate-x-2 group-focus-visible:translate-x-2 motion-reduce:transition-opacity motion-reduce:group-hover:translate-x-0 motion-reduce:group-hover:opacity-70">
                                    <ArrowRight className="h-[34px] w-[34px] text-brand" />
                                </span>
                                <span className="type-display text-[clamp(24px,2.6vw,36px)] font-bold leading-[1.1] text-brand">
                                    {service.slug === "identidade-visual" ? (
                                        <>
                                            IDENTIDADE
                                            <br />
                                            VISUAL
                                        </>
                                    ) : (
                                        service.shortLabel
                                    )}
                                </span>
                            </Link>
                        </motion.li>
                    ))}
                </ul>
            </div>
        </section>
    );
};


